import React from 'react';

export const overlay = () => {
    return <>
        <div style={{
            position: 'fixed',
            display:'block',
            width:'100%',
            height:'100%',
            top:0,
            left:0,
            right:0,
            bottom:0,
            backgroundColor:'transparent',
            zIndex:3
        }}/>
    </>
}

export const scrollToTop = (id) => {
    if(id) {
        $("#"+id).scrollTop(0);
    } else {
        window.scrollTo(0,0);
    }
}

export const decodeTipologica = (list, item, field) => {
    let decoded = '';
    if(Object.keys(item).length == 0 || list.length == 0) {
        return decoded;
    }
    let element = list.find(elem => elem.optionValue === item[field]);
    if(element) {
        decoded = element.optionLabel;
    }
    return decoded;
}